import { SLIPS } from "../types";

export const setSelectedSlips = (selectSlip: any) => {
  return {
    type: SLIPS.SLIPS_SET_SELECTED,
    payload: { ...selectSlip },
  };
};

export const clearSelectedSlips = () => {
  return {
    type: SLIPS.SLIPS_CLEAR_SELECTED,
  };
};
